module.exports = __webpack_public_path__ + "img/specialty1.edcdef1.png";